export default __webpack_public_path__ + "static/media/manufacturing1.9b025b3c.png";